<template>
    <div>
        <ul>
            <li><a>Yes</a></li>
            <li><a>No</a></li>
        </ul>
    </div>
</template>

<script>
    // import { mapActions } from 'vuex';

    export default {
        methods: {
            // ...mapActions([
            //     'logout'
            // ]),
            // logout(e) {
                // e.stopPropagation();
                // this.$store.dispatch('player/logout').then(() => {
                //     // https://forum.vuejs.org/t/best-practice-to-change-the-route-vuerouter-after-a-mutation-vuex/5631/9
                //     if (!this.$store.getters.error) {
                //         this.$router.replace('/login/');
                //     }
                // });
            // },

            // fullscreen(e) {
            //     e.stopPropagation();
            //     this.$store.dispatch('gameOS/fullscreen');
            // }
        },
    }
</script>

<style lang="scss" scoped>


</style>